import React, { useRef, useEffect, useCallback } from 'react';
import { FileTab } from '@/types';

interface ContextMenuProps {
  tab: FileTab;
  isGrouped: boolean;
  onClose: () => void;
  onCloseTab: () => void;
  onCloseOthers: () => void;
  onCloseAll: () => void;
  onPin: () => void;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({
  tab,
  isGrouped,
  onClose,
  onCloseTab,
  onCloseOthers,
  onCloseAll,
  onPin,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div className="context-menu" ref={menuRef}>
      <button className="context-menu-item" onClick={onCloseTab}>
        Close
      </button>
      <button className="context-menu-item" onClick={onCloseOthers}>
        Close Others
      </button>
      <button className="context-menu-item" onClick={onCloseAll}>
        Close All
      </button>
      <div className="context-menu-separator" />
      <button className="context-menu-item" onClick={onPin}>
        {tab.isPinned ? 'Unpin' : 'Pin'}
      </button>
      {isGrouped && (
        <>
          <div className="context-menu-separator" />
          <button className="context-menu-item">Ungroup</button>
        </>
      )}
    </div>
  );
};